import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Stack,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export interface ConfirmDialogButton {
  label: string;
  onClick: () => void;
  variant?: "primary" | "secondary";
}

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description?: string;
  buttons: ConfirmDialogButton[];
  onClose: () => void;
}

export default function ConfirmDialog({
  open,
  title,
  description,
  buttons,
  onClose,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 2,
          minWidth: 320,
          textAlign: "center",
        },
      }}
    >
      <DialogTitle sx={{ position: "relative", fontSize: 18 }}>
        {title}

        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        {description && (
          <Typography sx={{ mb: 2, color: "#555" }}>{description}</Typography>
        )}

        <Stack spacing={2}>
          {buttons.map((btn, index) => (
            <Button
              key={index}
              onClick={btn.onClick}
              sx={{
                height: 48,
                borderRadius: 8,
                background:
                  btn.variant === "secondary" ? "#DDE1EB" : "#0C1B4D",
                color: btn.variant === "secondary" ? "#475480" : "white",
                boxShadow: "none",
                "&:hover": {
                  background:
                    btn.variant === "secondary"
                      ? "#d3d7e2"
                      : "#122260",
                },
              }}
            >
              {btn.label}
            </Button>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
